"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _jquery = _interopRequireDefault(require("jquery"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _cccisdTable = _interopRequireDefault(require("cccisd-table"));
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _reactRouterDom = require("react-router-dom");
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _first2 = _interopRequireDefault(require("lodash/first"));
var _index = _interopRequireDefault(require("../addScopeBtn/index.js"));
var _index2 = _interopRequireDefault(require("../editScopeBtn/index.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Boilerplate = window.cccisd.boilerplate;
var ScopeTable = /*#__PURE__*/function (_React$Component) {
  _inherits(ScopeTable, _React$Component);
  function ScopeTable() {
    var _this;
    _classCallCheck(this, ScopeTable);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ScopeTable, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {});
    _defineProperty(_assertThisInitialized(_this), "_getDeleteBtn", function (id) {
      return /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
        title: /*#__PURE__*/_react["default"].createElement("span", {
          className: "glyphicon glyphicon-remove"
        }),
        className: "btn btn-danger tableBtn",
        isConfirm: true,
        confirmationMessage: "Are you sure you want to delete this scope?",
        onClick: _this.onScopeDelete.bind(null, id),
        isDisabled: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onScopeDelete", function (id) {
      var $this = _assertThisInitialized(_this);
      _jquery["default"].ajax({
        type: 'DELETE',
        url: Boilerplate.route('poly.api.v1.scope.destroy').replace('{scope}', id),
        data: {
          _token: Boilerplate.settings.csrfToken
        },
        dataType: 'json',
        success: function success(data) {
          $this.props.onLoadStart();
          $this._updateData();
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "AddScope", function (values) {
      var $this = _assertThisInitialized(_this);
      _jquery["default"].ajax({
        type: 'POST',
        url: Boilerplate.route('poly.api.v1.scope.store'),
        data: Object.assign(values, {
          _token: Boilerplate.settings.csrfToken
        }),
        dataType: 'json',
        success: function success(data) {
          $this.notifyThenUpdate();
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "AddScope", function (values) {
      var $this = _assertThisInitialized(_this);
      _jquery["default"].ajax({
        type: 'POST',
        url: Boilerplate.route('poly.api.v1.scope.store'),
        data: Object.assign(values, {
          _token: Boilerplate.settings.csrfToken
        }),
        dataType: 'json',
        success: function success(data) {
          $this.notifyThenUpdate();
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_updateData", function () {
      var $this = _assertThisInitialized(_this);
      _jquery["default"].ajax({
        type: 'GET',
        url: Boilerplate.route('poly.api.v1.scope.index'),
        data: {},
        dataType: 'json',
        success: function success(data) {
          if ($this.props.alwaysRedirectFirst) {
            $this.props.history.push("/tags/admin/scope/".concat(data[0].id));
          } else if (data.length === 1 && $this.props.redirectIfOne) {
            $this.props.history.push("/tags/admin/scope/".concat(data[0].id));
          } else {
            $this.setState({
              scopes: data
              // loading: false,
            });
            $this.props.onLoadComplete();
          }
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "notifyThenUpdate", function () {
      _this.refs.AddScopeBtn.refs.CreateScope.close();
      (0, _cccisdNotification["default"])({
        message: 'Scope Added Successfully',
        type: 'success',
        // can be 'success', 'info', 'warning', 'danger'
        duration: 8000 // time in milliseconds. 0 means infinite
      });
      _this._updateData();
    });
    _defineProperty(_assertThisInitialized(_this), "updateScope", function (id, values) {
      var $this = _assertThisInitialized(_this);
      _jquery["default"].ajax({
        type: 'PUT',
        url: Boilerplate.route('poly.api.v1.scope.update').replace('{scope}', id),
        data: Object.assign(values, {
          _token: Boilerplate.settings.csrfToken
        }),
        dataType: 'json',
        success: function success(data) {
          (0, _cccisdNotification["default"])({
            message: 'Tag Updated!',
            type: 'success',
            // can be 'success', 'info', 'warning', 'danger'
            duration: 8000 // time in milliseconds. 0 means infinite
          });
          $this._updateData();
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onScopeClick", function (id) {});
    return _this;
  }
  _createClass(ScopeTable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._updateData();
    }
  }, {
    key: "render",
    value: function render() {
      var $this = this;
      var columns = [{
        name: 'name',
        label: 'Name',
        "class": 'text-left',
        render: function render(value, row) {
          return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
            to: "/tags/admin/scope/".concat(row.id)
          }, value);
        }
      }, {
        name: 'actions',
        label: 'Actions',
        "class": 'text-center',
        render: function render(value, row) {
          var deleteBtn = $this._getDeleteBtn(row.id);
          return /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_index2["default"], {
            ref: "EditScopeBtn",
            initialValues: (0, _first2["default"])((0, _filter2["default"])($this.state.scopes, function (s) {
              return s.id === row.id;
            })),
            onSuccess: $this.updateScope.bind(null, row.id)
          }), ' ', deleteBtn);
        }
      }];
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h3", null, "Scopes"), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          textAlign: 'right'
        }
      }, /*#__PURE__*/_react["default"].createElement(_index["default"], {
        ref: "AddScopeBtn",
        onSuccess: this.AddScope
      })), /*#__PURE__*/_react["default"].createElement(_cccisdTable["default"], {
        ref: "scopeTable",
        data: this.state.scopes,
        columns: columns,
        orderBy: "name",
        isAscentOrder: true
      }));
    }
  }]);
  return ScopeTable;
}(_react["default"].Component);
_defineProperty(ScopeTable, "propTypes", {
  scopes: _propTypes["default"].array,
  onLoadComplete: _propTypes["default"].func,
  onLoadStart: _propTypes["default"].func,
  history: _propTypes["default"].object
});
_defineProperty(ScopeTable, "defaultProps", {
  scopes: [],
  onLoadStart: function onLoadStart() {},
  onLoadComplete: function onLoadComplete() {}
});
var _default = exports["default"] = ScopeTable;